import { log } from 'utils/errorLogger'

/**
 * Decodes and parses a stringified, encoded value
 * @example getDecodedData('"{\'id\': 123 }"') // { id: 123 }
 */
export const getDecodedData = (dataRaw: string): Record<string, any> => {
  let data = {}

  try {
    data = JSON.parse(decodeURI(dataRaw))
  } catch (e) {
    log('rogers', e, { extra: { dataRaw } })
  }

  return data
}
